interface ClickOutsideConfig {
  elementId: string
  callback: () => void
}

/**
 * Utility function to handle click outside events
 * @param config Configuration object containing:
 * - elementId: ID of the element to check clicks outside of
 * - callback: Function to call when click is outside
 */
export const handleClickElement = ({ elementId, callback }: ClickOutsideConfig): (() => void) | undefined => {
  const element = document.getElementById(elementId)
  if (!element) return undefined

  const handleClick = () => {
    callback?.()
  }

  element.addEventListener('click', handleClick)

  return () => {
    element.removeEventListener('click', handleClick)
  }
}
